import { useMemo, useCallback } from 'react'

const convertToFormData = (obj, formData = new FormData(), parentKey = null) => {
    if (!obj) return formData;

    Object.entries(obj).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
            return;
        }

        const formKey = parentKey ? `${parentKey}.${key}` : key;

        if (value instanceof File || value instanceof Blob) {
            formData.append(formKey, value);
        }
        else if (Array.isArray(value)) {
            if (value.length === 0) {
                return;
            }

            const isFileArray = value.every(item => item instanceof File || item instanceof Blob);
            if (isFileArray) {
                value.forEach(file => formData.append(formKey, file));
            }
            else if (value.every(item => typeof item !== 'object' || item === null)) {
                formData.append(`${formKey}`, value.join(','));

            }
            else {
                value.forEach((item, i) => {
                    if (item !== null && item !== undefined) {
                        if (typeof item === 'object' && !(item instanceof File) && !(item instanceof Blob)) {
                            convertToFormData(item, formData, `${formKey}[${i}]`);
                        } else if (item instanceof File || item instanceof Blob) {
                            formData.append(`${formKey}[${i}]`, item);
                        } else {
                            formData.append(`${formKey}`, item);
                        }
                    }
                });
            }
        }
        else if (typeof value === 'object' && value !== null) {
            const files = Object.values(value).filter(v => v instanceof File || v instanceof Blob);
            if (files.length === Object.keys(value).length && files.length > 0) {
                files.forEach(file => formData.append(key, file));
            } else {
                convertToFormData(value, formData, formKey);
            }
        }
        else {
            formData.append(formKey, value);
        }
    });

    return formData;
};



const useFormData = () => {
    const getFormData = useCallback((obj) => {
        return convertToFormData(obj);
    }, []);

    return {
        getFormData,
        convertToFormData
    };
};


export const useFormDataMemo = (obj, deps = []) => {
    return useMemo(() => {
        return convertToFormData(obj);
    }, [obj, ...deps]);
};

export default useFormData;
export { convertToFormData };

